import { render, staticRenderFns } from "./AmazeUserfile.vue?vue&type=template&id=9a8beca6&scoped=true"
import script from "./AmazeUserfile.vue?vue&type=script&lang=js"
export * from "./AmazeUserfile.vue?vue&type=script&lang=js"
import style0 from "./AmazeUserfile.vue?vue&type=style&index=0&id=9a8beca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8beca6",
  null
  
)

export default component.exports